var libs = {
    '100': '首都图书馆',
    '101': '朝阳区图书馆',
    '102': '东城区第一图书馆',
    '103': '西城区第一图书馆',
    '104': '平谷区图书馆',
    '105': '大兴区图书馆',
    '106': '怀柔图书馆',
    '107': '石景山区图书馆',
    '108': '东城区第二图书馆',
    '109': '西城区第二图书馆',
    '110': '海淀区图书馆',
    '111': '丰台区图书馆',
    '112': '顺义区图书馆',
    '113': '昌平区图书馆',
    '114': '门头沟区图书馆',
    '115': '通州区图书馆',
    '116': '房山区图书馆',
    '117': '延庆县图书馆',
    '118': '密云县图书馆',
    '119': '房山区燕山图书馆',
    '120': '西城区少儿图书馆',
    '121': '石景山区少儿图书馆',
    '122': '丰台少儿图书馆',
    '123': '朝阳区少儿图书馆',
    '200': '天津图书馆',
    '201': '和平区图书馆',
    '202': '泰达图书馆',
    '203': '北辰区图书馆',
    '204': '东丽区图书馆',
    '205': '武清区图书馆',
    '206': '西青区图书馆',
    '207': '河东区图书馆',
    '208': '河北区图书馆',
    '209': '河西区图书馆',
    '210': '南开区图书馆',
    '211': '大港区图书馆',
    '212': '塘沽区图书馆',
    '213': '津南区图书馆',
    '214': '汉沽区图书馆（天津市滨海新区汉沽图书馆）',
    '215': '宝坻区图书馆',
    '216': '红桥区图书馆',
    '217': '蓟县图书馆',
    '218': '静海县图书馆',
    '219': '宁河县图书馆',
    '220': '天津市少儿图书馆',
    '221': '和平区少儿馆',
    '222': '河西区少儿馆',
    '223': '南开少儿馆',
    '224': '河北区少儿馆',
    '225': '西青区图书馆',
    '226': '红桥区少儿馆',
    '227': '塘沽少儿馆',
    '228': '汉沽区少儿馆',
    '229': '北辰区少儿馆',
    '300': '河北省图书馆',
    '301': '保定市图书馆',
    '302': '承德市图书馆',
    '303': '廊坊市图书馆',
    '304': '秦皇岛图书馆',
    '305': '石家庄市图书馆',
    '306': '唐山市图书馆',
    '307': '邢台市图书馆',
    '308': '沧州市图书馆',
    '309': '衡水市图书馆',
    '310': '邯郸市图书馆',
    '311': '张家口市图书馆',
    '312': '石家庄市少儿馆',
    '400': '山西省图书馆',
    '401': '太原市图书馆',
    '402': '阳泉市图书馆',
    '403': '长治市图书馆',
    '404': '大同市图书馆',
    '405': '吕梁市图书馆',
    '406': '朔州市图书馆',
    '407': '大同市少儿馆',
    '408': '晋城市图书馆',
    '409': '山西省少年儿童图书馆',
    '500': '内蒙古图书馆',
    '501': '呼和浩特市图书馆',
    '502': '包头市图书馆',
    '503': '乌兰察布市图书馆',
    '504': '赤峰市图书馆',
    '505': '呼伦贝尔市图书馆',
    '506': '巴彦淖尔市图书馆',
    '507': '兴安盟图书馆',
    '508': '通辽市图书馆',
    '509': '锡林郭勒盟图书馆',
    '510': '鄂尔多斯市图书馆',
    '511': '阿拉善盟图书馆',
    '512': '乌海市图书馆',
    '600': '辽宁省图书馆',
    '601': '沈阳市图书馆',
    '602': '大连市图书馆',
    '603': '鞍山市图书馆',
    '604': '抚顺市图书馆',
    '605': '丹东市图书馆',
    '606': '本溪市图书馆',
    '607': '营口市图书馆',
    '608': '铁岭市图书馆',
    '609': '阜新市图书馆',
    '610': '朝阳市图书馆',
    '611': '盘锦市图书馆',
    '612': '锦州市图书馆',
    '613': '葫芦岛市图书馆',
    '614': '辽阳市图书馆',
    '615': '丹东市少儿馆',
    '616': '大连市少儿馆',
    '617': '鞍山少儿馆',
    '618': '本溪少儿馆',
    '619': '锦州少儿馆',
    '620': '盘锦市少儿馆',
    '621': '沈阳市少儿馆',
    '622': '铁岭市少儿馆',
    '623': '营口市少儿馆',
    '624': '辽阳市少年儿童图书馆',
    '700': '吉林省图书馆',
    '701': '长春图书馆',
    '702': '吉林市图书馆',
    '703': '通化市图书馆',
    '704': '白城市图书馆',
    '705': '松原市图书馆',
    '706': '延边朝鲜族自治州图书馆',
    '707': '白山市图书馆',
    '708': '辽源市图书馆',
    '709': '四平市图书馆',
    '710': '延吉市少儿馆',
    '711': '长春市少儿馆',
    '800': '黑龙江省图书馆',
    '801': '哈尔滨市图书馆',
    '802': '伊春市图书馆',
    '803': '牡丹江市图书馆',
    '804': '牡丹江朝鲜族图书馆',
    '805': '大庆市图书馆',
    '806': '鹤岗市图书馆',
    '807': '齐齐哈尔市图书馆',
    '808': '鸡西市图书馆',
    '809': '双鸭市图书馆',
    '810': '七台河市图书馆',
    '811': '大兴安岭地区图书馆',
    '812': '绥化市少儿馆',
    '900': '上海图书馆',
    '901': '普陀区图书馆',
    '902': '闵行区图书馆',
    '903': '虹口区图书馆',
    '904': '长宁区图书馆',
    '905': '奉贤区图书馆',
    '906': '青浦区图书馆',
    '907': '浦东新区图书馆',
    '908': '黄浦区图书馆',
    '909': '黄浦区明复图书馆',
    '910': '徐汇区图书馆',
    '911': '静安区图书馆',
    '912': '闸北区图书馆',
    '913': '杨浦区延吉图书馆',
    '914': '杨浦区图书馆',
    '915': '宝山区图书馆',
    '916': '嘉定区图书馆',
    '917': '浦东新区陆家嘴图书馆',
    '918': '浦东新区新川沙图书馆',
    '919': '金山区图书馆',
    '920': '松江区图书馆',
    '921': '崇明县图书馆',
    '922': '上海少年儿童图书馆',
    '923': '长宁区少儿馆',
    '924': '普陀区少儿馆',
    '925': '杨浦区少儿馆',
    '926': '闸北区少儿馆',
    '1000': '南京图书馆',
    '1001': '金陵图书馆',
    '1002': '无锡市图书馆',
    '1003': '盐城市图书馆',
    '1004': '扬州市图书馆',
    '1005': '常州图书馆',
    '1006': '苏州图书馆',
    '1007': '泰州市图书馆',
    '1008': '连云港市图书馆',
    '1009': '淮安市图书馆',
    '1010': '徐州市图书馆',
    '1011': '南通市图书馆',
    '1012': '宿迁市图书馆',
    '1013': '镇江市图书馆',
    '1014': '连云港市少儿馆',
    '1015': '南通市少儿馆',
    '1016': '徐州少儿馆',
    '1017': '扬州少儿馆',
    '1100': '浙江图书馆',
    '1101': '杭州图书馆',
    '1102': '宁波市图书馆',
    '1103': '温州市图书馆',
    '1104': '绍兴图书馆',
    '1105': '嘉兴市图书馆',
    '1106': '湖州市图书馆',
    '1107': '金华市图书馆',
    '1108': '台州市图书馆',
    '1109': '舟山市图书馆',
    '1110': '衢州市图书馆',
    '1111': '丽水市图书馆',
    '1112': '杭州少儿馆',
    '1113': '金华少儿馆',
    '1114': '温州市少儿馆',
    '1200': '安徽省图书馆',
    '1201': '马鞍山市图书馆',
    '1202': '芜湖市图书馆',
    '1203': '铜陵市图书馆',
    '1204': '安庆市图书馆',
    '1205': '合肥市图书馆',
    '1206': '蚌埠市图书馆',
    '1207': '淮南市图书馆',
    '1208': '淮北市图书馆',
    '1209': '阜阳市图书馆',
    '1210': '滁州市图书馆',
    '1211': '宣城市图书馆',
    '1212': '池州市图书馆',
    '1213': '黄山市图书馆',
    '1214': '亳州市图书馆',
    '1215': '宿州市图书馆',
    '1216': '合肥市少儿馆',
    '1217': '淮南市少儿馆',
    '1300': '福建省图书馆',
    '1301': '厦门市图书馆',
    '1302': '福州市图书馆',
    '1303': '泉州市图书馆',
    '1304': '龙岩图书馆',
    '1305': '三明市图书馆',
    '1306': '莆田市图书馆',
    '1307': '漳州市图书馆',
    '1308': '南平市图书馆',
    '1309': '宁德市图书馆',
    '1310': '福建省少儿图书馆',
    '1311': '福州市少儿图书馆',
    '1312': '厦门市少儿馆',
    '1313': '三明市少儿馆',
    '1314': '平潭综合实验区图书馆',
    '1400': '江西省图书馆',
    '1401': '南昌市图书馆',
    '1402': '抚州市图书馆',
    '1403': '吉安市图书馆',
    '1404': '景德镇市图书馆',
    '1405': '九江市图书馆',
    '1406': '萍乡市图书馆',
    '1407': '赣州市图书馆',
    '1408': '新余市图书馆',
    '1409': '上饶市图书馆',
    '1410': '鹰潭市图书馆',
    '1411': '宜春市图书馆',
    '1500': '山东省图书馆',
    '1501': '济南市图书馆',
    '1502': '青岛市图书馆',
    '1503': '济宁市图书馆',
    '1504': '威海市图书馆',
    '1505': '烟台图书馆',
    '1506': '德州市图书馆',
    '1507': '淄博市图书馆',
    '1508': '聊城市海源阁图书馆',
    '1509': '临沂市图书馆',
    '1510': '枣庄市图书馆',
    '1511': '莱芜市图书馆',
    '1512': '滨州市图书馆',
    '1513': '东营市图书馆',
    '1514': '日照市图书馆',
    '1515': '泰安市图书馆',
    '1516': '潍坊市图书馆',
    '1517': '烟台少儿馆',
    '1518': '菏泽市图书馆',
    '1600': '河南省图书馆',
    '1601': '郑州图书馆',
    '1602': '安阳市图书馆',
    '1603': '鹤壁市图书馆',
    '1604': '洛阳市图书馆',
    '1605': '平顶山市图书馆',
    '1606': '信阳市图书馆',
    '1607': '周口市图书馆',
    '1608': '许昌市图书馆',
    '1609': '开封市图书馆',
    '1610': '新乡市图书馆',
    '1611': '焦作市图书馆',
    '1612': '濮阳市图书馆',
    '1613': '漯河市图书馆',
    '1614': '三门峡市图书馆',
    '1615': '南阳市图书馆',
    '1616': '河南省少儿图书馆',
    '1617': '安阳少儿馆',
    '1618': '洛阳市少儿图书馆',
    '1619': '平顶山市少年儿童图书馆',
    '1620': '济源市图书馆',
    '1700': '湖北省图书馆',
    '1701': '武汉图书馆',
    '1702': '黄冈市图书馆',
    '1703': '十堰市图书馆',
    '1704': '宜昌市图书馆',
    '1705': '黄石市图书馆',
    '1706': '荆州市图书馆',
    '1707': '襄阳市图书馆',
    '1708': '孝感市图书馆',
    '1709': '鄂州市图书馆',
    '1710': '随州市图书馆',
    '1711': '荆门市图书馆',
    '1712': '咸宁市图书馆',
    '1713': '恩施州图书馆',
    '1714': '武汉市少儿馆',
    '1715': '荆州市少儿馆',
    '1716': '襄阳市少儿馆',
    '1717': '十堰市少儿馆',
    '1718': '天门市图书馆',
    '1800': '湖南图书馆',
    '1801': '长沙市图书馆',
    '1802': '衡阳市图书馆',
    '1803': '湖南省湘潭市图书馆',
    '1804': '岳阳市图书馆',
    '1805': '株洲市图书馆',
    '1806': '常德市图书馆',
    '1807': '郴州市图书馆',
    '1808': '湘西自治州图书馆',
    '1809': '怀化市图书馆',
    '1810': '益阳市图书馆',
    '1811': '邵阳松坡图书馆',
    '1812': '永州市图书馆',
    '1813': '湖南省少儿馆',
    '1814': '衡阳少儿馆',
    '1815': '邵阳少儿馆',
    '1816': '湘潭少儿馆',
    '1900': '广东省立中山图书馆',
    '1901': '广州图书馆',
    '1902': '深圳图书馆',
    '1903': '东莞图书馆',
    '1904': '惠州慈云图书馆',
    '1905': '清远市图书馆',
    '1906': '汕头市图书馆',
    '1907': '肇庆市图书馆',
    '1908': '珠海市图书馆',
    '1909': '中山市中山图书馆',
    '1910': '韶关市图书馆',
    '1911': '佛山市图书馆',
    '1912': '江门市五邑图书馆',
    '1913': '湛江市图书馆',
    '1914': '茂名市图书馆',
    '1915': '梅州市剑英图书馆',
    '1916': '汕尾市图书馆',
    '1917': '阳江市图书馆',
    '1918': '潮州市图书馆',
    '1919': '揭阳市图书馆',
    '1920': '云浮市图书馆',
    '1921': '河源市图书馆',
    '1922': '广州少儿馆',
    '1923': '东莞少儿馆',
    '1924': '深圳少儿馆',
    '1925': '湛江市少儿馆',
    '2000': '海南省图书馆',
    '2001': '三亚市图书馆',
    '2002': '海口图书馆',
    '2003': '儋州市图书馆',
    '2100': '广西壮族自治区图书馆',
    '2101': '南宁市图书馆',
    '2102': '北海市图书馆',
    '2103': '玉林市图书馆',
    '2104': '贵港市图书馆',
    '2105': '钦州市图书馆',
    '2106': '崇左市图书馆',
    '2107': '百色市图书馆',
    '2108': '防城港市图书馆',
    '2109': '广西少儿馆',
    '2110': '南宁少儿馆',
    '2111': '北海市少儿馆',
    '2200': '广西壮族自治区桂林图书馆',
    '2201': '梧州市图书馆',
    '2202': '柳州市图书馆',
    '2203': '贺州市图书馆',
    '2204': '河池市图书馆',
    '2205': '来宾市图书馆',
    '2300': '重庆图书馆',
    '2301': '渝中区图书馆',
    '2302': '北碚区图书馆',
    '2303': '沙坪坝区图书馆',
    '2304': '南岸区图书馆',
    '2305': '九龙坡区图书馆',
    '2306': '大渡口区图书馆',
    '2307': '黔江区图书馆',
    '2308': '长寿区图书馆',
    '2309': '渝北区图书馆',
    '2310': '巴南区图书馆',
    '2311': '永川区图书馆',
    '2312': '合川区图书馆',
    '2313': '江北区图书馆',
    '2314': '江津区图书馆',
    '2315': '万州区图书馆',
    '2316': '万盛经济技术开发区图书馆',
    '2317': '綦江区图书馆',
    '2318': '涪陵区图书馆',
    '2319': '南川区图书馆',
    '2320': '双桥经济技术开发区图书馆',
    '2321': '大足县图书馆',
    '2322': '潼南县图书馆',
    '2323': '秀山县图书馆',
    '2324': '璧山县图书馆',
    '2325': '垫江县图书馆',
    '2326': '云阳县图书馆',
    '2327': '武隆县图书馆',
    '2328': '巫山县图书馆',
    '2329': '荣昌县图书馆',
    '2330': '巫溪县图书馆',
    '2331': '忠县图书馆',
    '2332': '石柱县图书馆',
    '2333': '梁平县图书馆',
    '2334': '丰都县图书馆',
    '2335': '酉阳县图书馆',
    '2336': '铜梁县图书馆',
    '2337': '城口县图书馆',
    '2338': '开县图书馆',
    '2339': '奉节县图书馆',
    '2340': '彭水县图书馆',
    '2341': '重庆市少儿馆',
    '2342': '涪陵区少儿馆',
    '2400': '四川省图书馆',
    '2401': '成都市图书馆',
    '2402': '绵阳市图书馆',
    '2403': '泸州市图书馆',
    '2404': '攀枝花市图书馆',
    '2405': '宜宾市图书馆',
    '2406': '资阳市图书馆',
    '2407': '遂宁市图书馆',
    '2408': '雅安市图书馆',
    // '2409': '凉山彝族自治州图书馆',
    '2410': '南充市图书馆',
    '2411': '巴中市图书馆',
    '2412': '广元市图书馆',
    '2413': '德阳市图书馆',
    '2414': '达州市图书馆',
    '2415': '甘孜州图书馆',
    '2416': '阿坝州图书馆',
    '2417': '自贡市图书馆',
    '2418': '内江市图书馆',
    '2419': '广安市图书馆',
    '2420': '眉山市图书馆',
    '2421': '乐山市图书馆',
    '2422': '泸州市少年儿童图书馆',
    '2500': '贵州省图书馆',
    '2501': '贵阳市图书馆',
    '2502': '遵义市图书馆',
    '2503': '铜仁市图书馆',
    '2504': '毕节市图书馆',
    '2505': '黔南州图书馆',
    '2506': '六盘水市图书馆',
    '2507': '黔东南州图书馆',
    '2508': '黔西南州图书馆',
    '2509': '安顺市图书馆',
    '2510': '贵阳市少年儿童图书馆',
    '2600': '云南省图书馆',
    '2601': '昆明市图书馆',
    '2602': '红河州图书馆',
    '2603': '文山州图书馆',
    '2604': '保山市图书馆',
    '2605': '普洱市图书馆',
    '2606': '西双版纳傣族自治州图书馆',
    '2607': '曲靖市图书馆',
    '2608': '昭通地区图书馆',
    '2609': '楚雄州图书馆',
    '2610': '玉溪市图书馆',
    '2611': '大理州图书馆',
    '2612': '德宏州图书馆',
    '2613': '丽江地区图书馆',
    '2614': '怒江州图书馆',
    '2615': '迪庆州图书馆',
    '2616': '临沧州地区图书馆',
    '2617': '昆明市少儿馆',
    '2618': '曲靖市少儿馆',
    '2700': '西藏自治区图书馆',
    '2701': '林芝地区图书馆',
    '2702': '昌都图书馆',
    '2703': '阿里图书馆',
    '2704': '山南图书馆',
    '2705': '那曲地区图书馆',
    '2800': '陕西省图书馆',
    '2801': '西安图书馆',
    '2802': '咸阳图书馆',
    '2803': '宝鸡市图书馆',
    '2804': '安康市图书馆',
    '2805': '铜川市图书馆',
    '2806': '商洛市图书馆',
    '2807': '延安市图书馆',
    '2808': '渭南市图书馆',
    '2809': '安康少儿馆',
    '2810': '安康市汉滨区少儿馆',
    '2900': '甘肃省图书馆',
    '2901': '兰州市图书馆',
    '2902': '嘉峪关市图书馆',
    '2903': '金昌市图书馆',
    '2904': '白银市图书馆',
    '2905': '天水市图书馆',
    '2906': '灵台县图书馆',
    '2907': '庆阳市图书馆',
    '2908': '临夏州图书馆',
    '2909': '甘南州图书馆',
    '2910': '酒泉市图书馆',
    '2911': '定西市图书馆',
    '2912': '陇南市图书馆',
    '2913': '甘肃矿区图书馆',
    '2914': '张掖市图书馆',
    '2915': '武威市图书馆',
    '2916': '兰州少儿馆',
    '2917': '嘉峪关市少儿图书馆',
    '3000': '青海省图书馆',
    '3001': '西宁市图书馆',
    '3002': '海北州图书馆',
    '3003': '海南州图书馆',
    '3004': '海西州图书馆',
    '3005': '果洛州图书馆',
    '3006': '黄南州图书馆',
    '3007': '玉树州图书馆',
    '3100': '宁夏回族自治区图书馆',
    '3101': '银川市图书馆',
    '3102': '吴忠市图书馆',
    '3103': '石嘴山市图书馆',
    '3104': '固原市图书馆',
    '3105': '中卫市图书馆',
    '3200': '新疆维吾尔自治区图书馆',
    '3201': '乌鲁木齐市图书馆',
    '3202': '喀什地区图书馆',
    '3203': '伊犁州图书馆',
    '3204': '巴音郭楞蒙古自治州图书馆',
    '3205': '昌吉州图书馆',
    '3206': '塔城地区图书馆',
    '3207': '阿勒泰地区图书馆',
    '3208': '和田地区图书馆',
    '3209': '阿克苏地区图书馆',
    '3210': '克孜勒苏柯尔克孜自治州图书馆',
    '3211': '新疆博尔塔拉蒙古自治州图书馆',
    '3212': '哈密地区图书馆',
    '3213': '吐鲁番地区图书馆',
    '3214': '克拉玛依市图书馆',
    '3300': '新疆生产建设兵团文化中心',
    '3301': '新疆兵团第六师数字图书馆',
    '3302': '新疆兵团第八师数字图书馆',
    '0921': '崇明区图书馆',
    '0903': '虹口区图书馆',
    '0701': '长春市图书馆',
    '0608': '新宾满族自治县图书馆',
    '1243': '洪江市图书馆',
    '2409': '西昌市地方志编纂中心',
	'2905': '秦安县图书馆'
}

export default {
    libs
}
